import { useDispatch, useSelector } from 'react-redux';
import {
  fetchReportingFilters1a,
  fetchReportingFilters2a,
  fetchReportingFilters1b,
  fetchReportingFilterData,
  fetchReporting2aFilterData,
  fetchAdminReportingDetail,
  fetchStudentReportingDetail,
  fetchReportingExamsFilterDataType,
  fetchExamsReportingDetail,
  fetchListClassModulesFromReporting,
  clearReportingClassModules,
} from "@store/actions/reportingAction";
import { AppState, AppDispatch } from '../store';
import { setAdminReportingFilterSelected, setAdminReporting2aFilterSelected } from '@store/reducers/reportingReducer';
import { IReportParams } from '@features/admin/reporting/reportPractice/interfaces';

type ReportingDataFilterParams = {
  province2: string | null;
  ward2: string | null;
  school_ids?: string,
  class_ids?: string,
  module_ids?: string,
  user_ids?: string,
  date_from?: string,
  date_to?: string
}

export function useAdminReporting() {

  const dispatch: AppDispatch = useDispatch();

  const adminReportingData1a = useSelector((state: AppState) => state.reporting.adminReportingData1a)
  const adminReportingData2a = useSelector((state: AppState) => state.reporting.adminReportingData2a)
  const adminReportingData1b = useSelector((state: AppState) => state.reporting.adminReportingData1b)
  const adminReportingFilter = useSelector((state: AppState) => state.reporting.adminReportingFilter)
  const adminReporting2aFilter = useSelector((state: AppState) => state.reporting.adminReporting2aFilter)
  const adminReportingFilterSelected = useSelector((state: AppState) => state.reporting.adminReportingFilterSelected)
  const adminReporting2aFilterSelected = useSelector((state: AppState) => state.reporting.adminReporting2aFilterSelected)
  const loading = useSelector((state: AppState) => state.reporting.loading)
  const downloadReportData1aUrl = useSelector((state: AppState) => state.reporting.downloadReportData1aUrl)
  const downloadReportData2aUrl = useSelector((state: AppState) => state.reporting.downloadReportData2aUrl)
  const downloadReportData1bUrl = useSelector((state: AppState) => state.reporting.downloadReportData1bUrl)
  const loadingReporting = useSelector((state: AppState) => state.reporting.loadingReporting)
  const adminReportingDetail = useSelector((state: AppState) => state.reporting.adminReportingDetail)
  const studentReportingDetail = useSelector((state: AppState) => state.reporting.studentReportingDetail)
  const examsReporting = useSelector((state: AppState) => state.reporting.examsReporting)
  const downloadExamsReportingUrl = useSelector((state: AppState) => state.reporting.downloadExamsReportingUrl)
  const loadingExamsReporting = useSelector((state: AppState) => state.reporting.loadingExamsReporting)
  const examsReportingDetail = useSelector((state: AppState) => state.reporting.examsReportingDetail)
  const classList = useSelector((state: AppState) => state.class.classList)
  const classModules = useSelector((state: AppState) => state.reporting.classModules)


  const fetchReportingFilters1aAction = (filters: ReportingDataFilterParams) => {
    dispatch(fetchReportingFilters1a(filters))
  }
    const fetchReportingFilters2aAction = (filters: IReportParams) => {
      dispatch(fetchReportingFilters2a(filters))
    }

  const fetchReportingFilters1bAction = (filters: ReportingDataFilterParams) => {
    dispatch(fetchReportingFilters1b(filters))
  }

  const fetchReportingFilterDataAction = (filters: ReportingDataFilterParams) => {
    dispatch(fetchReportingFilterData(filters))
  }
  const fetchReporting2aFilterDataAction = (filters: IReportParams) => {
    dispatch(fetchReporting2aFilterData(filters))
  }

  const updateAdminReportingFilterSelected = (filters: ReportingDataFilterParams) => {
    dispatch(setAdminReportingFilterSelected(filters))
  }
  const updateAdminReporting2aFilterSelected = (filters: IReportParams) => {
    dispatch(setAdminReporting2aFilterSelected(filters))
  }
  const fetchAdminReportingDetailAction = (filters: { submodule_id: string; student_id: string }) => {
    dispatch(fetchAdminReportingDetail(Number(filters.submodule_id), Number(filters.student_id)))
  }
  const fetchStudentReportingDetailAction = (filters: { submodule_id: string }) => {
    dispatch(fetchStudentReportingDetail(Number(filters.submodule_id)))
  }
  const fetchExamsReportingAction = (filters: ReportingDataFilterParams) => {
    dispatch(fetchReportingExamsFilterDataType(filters))
  }
  const fetchExamsReportingDetailAction = (filters: { student_id: string; submodule_id: string }) => {
    dispatch(fetchExamsReportingDetail(Number(filters.student_id), Number(filters.submodule_id)))
  }
  const fetchListClassModulesAction = (page: number, pageSize: number, classId: number, status?: number | null) => {
    dispatch((fetchListClassModulesFromReporting as any)({ page, pageSize, classId, status }))
  }

  const clearReportingClassModulesAction = () => {
    dispatch(clearReportingClassModules())
  }
  return {
    adminReportingData1a,
    adminReportingData2a,
    adminReportingData1b,
    adminReportingFilter,
    adminReporting2aFilter,
    fetchReportingFilters1aAction,
    fetchReportingFilters2aAction,
    fetchReportingFilters1bAction,
    fetchReportingFilterDataAction,
    fetchReporting2aFilterDataAction,
    updateAdminReportingFilterSelected,
    updateAdminReporting2aFilterSelected,
    adminReportingFilterSelected,
    adminReporting2aFilterSelected,
    downloadReportData1aUrl,
    downloadReportData2aUrl,
    downloadReportData1bUrl,
    loading,
    loadingReporting,
    adminReportingDetail,
    studentReportingDetail,
    fetchAdminReportingDetailAction,
    fetchStudentReportingDetailAction,
    examsReporting,
    downloadExamsReportingUrl,
    loadingExamsReporting,
    fetchExamsReportingAction,
    examsReportingDetail,
    fetchExamsReportingDetailAction,
    classList,
    fetchListClassModulesAction,
    clearReportingClassModulesAction,
    classModules,
  }
}
